import { render, staticRenderFns } from "./DrawerUnidayUniversity.vue?vue&type=template&id=119eabaa&scoped=true&"
import script from "./DrawerUnidayUniversity.vue?vue&type=script&lang=js&"
export * from "./DrawerUnidayUniversity.vue?vue&type=script&lang=js&"
import style0 from "./DrawerUnidayUniversity.vue?vue&type=style&index=0&id=119eabaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119eabaa",
  null
  
)

export default component.exports